import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { tabsClasses } from '@mui/material/Tabs';

import Calendar from './lists/calendar';
import Reservation from './lists/reservation';
import PageHeader from '../../common/page_header';

const ReservationsPage = () => {
    const [tab, setTab] = useState(0);

    const renderView = () => {
        if (tab === 0) {
            return <Calendar/>;
        }
        return <Reservation/>
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader title="Rezerwacje"/>

            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => setTab(value) }
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Kalendarz produktów pod rezerwacje"/>
                    <Tab label="Rezerwacje użytkowników"/>
                </Tabs>
            </Box>

            <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                { renderView() }
            </Box>
        </Box>
    );
};

export default ReservationsPage;